<template>
  <LayoutApplicationStyle>
    <div class="pp-wrap">
      <PostPurchaseSteps :current="3" />

      <section class="pp-hero">
        <div class="pp-kick">{{ copy.kick }}</div>
        <!-- eslint-disable-next-line vue/no-v-html -->
        <h1 v-html="copy.title"></h1>
        <p class="pp-sub">{{ copy.sub }}</p>

        <!-- Mobile: the CTA sits above the steps; desktop below. CSS toggles the two. -->
        <div class="pp-m-cta">
          <button class="pp-btn pp-teal" type="button" @click="next">
            {{ copy.cta }} <ArrowIcon />
          </button>
        </div>

        <div class="pp-grid">
          <div v-for="(step, i) in copy.steps" :key="step.title" class="pp-st">
            <div class="pp-stn">{{ String(i + 1).padStart(2, '0') }}</div>
            <div class="pp-stt">{{ step.title }}</div>
            <!-- eslint-disable-next-line vue/no-v-html -->
            <p v-html="step.body"></p>
          </div>
        </div>

        <div class="pp-cta">
          <button class="pp-btn pp-teal" type="button" @click="next">
            {{ copy.cta }} <ArrowIcon />
          </button>
        </div>
      </section>
    </div>
  </LayoutApplicationStyle>
</template>

<script>
import { onMounted } from '@nuxtjs/composition-api';
import LayoutApplicationStyle from '../LayoutApplicationStyle.vue';
import PostPurchaseSteps from '../PostPurchaseSteps.vue';
import ArrowIcon from '../ArrowIcon.vue';
import { Installation } from '../../constants/PostPurchase';
import useRegistration from '../../hooks/useRegistration';
import track from '../../utils/postPurchaseTrack';

export default {
  name: 'InstallationPage',
  components: { ArrowIcon, LayoutApplicationStyle, PostPurchaseSteps },
  setup(_, { emit }) {
    const { state } = useRegistration();

    onMounted(() => track(state, 'installation-viewed'));

    return { copy: Installation, next: () => emit('submit') };
  },
};
</script>
